import dataMonitorMeasureListItem from "../../../dataMonitor/DataMonitorMeasureListItem";

export default {
  name: 'obdDataMonitorMeasureListItem',

  extends: dataMonitorMeasureListItem,

  data() {
    return {
      // 親コンポーネントの名称をオーバーライド
      parentComponentName: 'ObdDataMonitorMeasureList'
    };
  },
};
